import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Frame, SelfieCamService, LabelJustification } from '../_services/selfie-cam.service';
import { PhotoService } from '../_services/photo.service';
import { HttpClient } from '@angular/common/http';

@Component({
  templateUrl: './selfie-cam-filter-generator.component.html',
  styleUrls: ['./selfie-cam-filter-generator.component.css']
})
export class SelfieCamFilterGeneratorComponent implements OnInit {

  private colorChangedSubject = new Subject();
  private colorChangedObservable =  this.colorChangedSubject.pipe(debounceTime(50));
  private textChangedSubject = new Subject();
  private textChangedObservable = this.textChangedSubject.pipe(debounceTime(250));

  private frameXml: string;
  private pic1Img: any;
  private pic2Img: any;

  public img1Name: string;
  public img1Error: boolean;
  public img2Name: string;
  public img2Error: boolean;
  public hasColor1: boolean;
  public hasColor2: boolean;
  public colorError = false;

  @ViewChild('mainImg', {static: false})
  private imgRef: ElementRef;

  public file: File;
  public loaded: boolean;
  public working: boolean;
  public frames: Frame[];

  public _selectedFrame: Frame;
  get selectedFrame(): Frame {
    return this._selectedFrame;
  }
  set selectedFrame(val: Frame) {
    this._selectedFrame = val;
    this.selectFrame(val);
  }

  public _color1 = '#FF00DF';
  get color1(): string {
    return this._color1;
  }
  set color1(val: string) {
    this._color1 = val;
    this.colorChangedSubject.next();
  }

  public _color2 = '#12FF00';
  get color2(): string {
    return this._color2;
  }
  set color2(val: string) {
    this._color2 = val;
    this.colorChangedSubject.next();
  }

  public _fontColor = '#999999';
  get fontColor(): string {
    return this._fontColor;
  }
  set fontColor(val: string) {
    this._fontColor = val;
    this.colorChangedSubject.next();
  }

  public _text = 'Sample text';
  get text(): string {
    return this._text;
  }
  set text(val: string) {
    this._text = val;
    this.textChangedSubject.next();
  }

  constructor(private bsModalRef: BsModalRef, private photoService: PhotoService, private selfieCamService: SelfieCamService, private httpClient: HttpClient) {}

  public setPng1(file: File) {

    this.img1Error = false;

    if (file.type !== 'image/png') {

      this.img1Error = true;
      return;
    }

    this.img1Name = file.name;
    this.processImage(file, img => {
      this.pic1Img = img;
    });
  }

  public setPng2(file: File) {

    this.img2Error = false;

    if (file.type !== 'image/png') {

      this.img2Error = true;
      return;
    }

    this.img2Name = file.name;
    this.processImage(file, img => {
      this.pic2Img = img;
    });
  }

  processImage(file: File, callback: (img: any) => void) {
    const self = this;
    const reader = new FileReader();
    this.working = true;
    reader.readAsDataURL(file);
    reader.onload = () => {
      const image = document.createElement('img');
      image.crossOrigin = 'Anonymous';
      image.setAttribute('crossOrigin', 'anonymous');
      image.src = <string>reader.result;
      image.onload = function() {
        callback(image);
        self.apply();
        self.working = false;
      };
    };
  }

  private drawImageCentered(ctx: CanvasRenderingContext2D, img: HTMLImageElement, locationX: number, locationY: number, width: number, height: number) {
    const ratio = Math.min(width / img.width, height / img.height);

    const destWidth = img.width * ratio;
    const destHeight = img.height * ratio;
    const destLocationX = locationX + width / 2 - destWidth / 2;
    const destLocationY = locationY + height / 2 - destHeight / 2;

    ctx.drawImage(img, destLocationX, destLocationY, destWidth, destHeight);
  }

  public apply() {
    const colorCodeValidator = /^#([A-Fa-f0-9]{6})$/;
    if (!colorCodeValidator.test(this.color1) || !colorCodeValidator.test(this.color2)) {
      this.colorError = true;
    } else {
      this.colorError = false;
    }

    if (this.frameXml) {
      const canvas = document.createElement('canvas');
      canvas.height = 1350;
      canvas.width = 1080;

      const ctx = canvas.getContext('2d');

      // replace colors
      const svg = this.frameXml.replace(/#FF00DF/gi, this.color1).replace(/#12FF00/gi, this.color2);

      // Hacky hack for Safari 11
      const data = 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);

      const self = this;
      const frameImg = document.createElement('img');
      frameImg.onload = function() {
        // frame image
        ctx.drawImage(frameImg, 0, 0, 1080, 1350);

        // pics 1&2
        if (self.pic1Img) {
          self.drawImageCentered(
            ctx,
            self.pic1Img,
            self.selectedFrame.image1X,
            self.selectedFrame.image1Y,
            self.selectedFrame.image1Width,
            self.selectedFrame.image1Height
          );
        }
        if (self.pic2Img) {
          self.drawImageCentered(
            ctx,
            self.pic2Img,
            self.selectedFrame.image2X,
            self.selectedFrame.image2Y,
            self.selectedFrame.image2Width,
            self.selectedFrame.image2Height
          );
        }

        // text
        if (self.text && self.selectedFrame.labelX) {
          ctx.font = `${self.selectedFrame.labelFontSize}px ${self.selectedFrame.labelFont}`;
          ctx.fillStyle = self.fontColor;
          const textDim = ctx.measureText(self.text);
          const lablelLeft = self.GetTextLeftLocation(textDim.width);
          const labelTop = self.selectedFrame.labelY + self.selectedFrame.labelFontSize;
          ctx.fillText(self.text, lablelLeft, labelTop);
        }

        self.imgRef.nativeElement.onload = () => {
          self.working = false;
        };

        self.imgRef.nativeElement.src = canvas.toDataURL();
      };
      frameImg.src = data;
    }
  }

  private GetTextLeftLocation(textWidth: number): number {
    if (this.selectedFrame.labelJustification === LabelJustification.Centered) {
      return this.selectedFrame.labelX - textWidth / 2;
    } else if (this.selectedFrame.labelJustification === LabelJustification.Right) {
      return this.selectedFrame.labelX - textWidth;
    } else {
      return this.selectedFrame.labelX;
    }
  }

  private selectFrame(frame: Frame) {
    this.working = true;
    this._selectedFrame = frame;
    const options = { responseType: 'text' as 'text' };
    this.httpClient.get(window.location.origin + this.selectedFrame.backgroundPngUrl, options).subscribe(resp => {
      this.frameXml = <string>resp;
      this.hasColor1 = this.frameXml.indexOf('#FF00DF') !== -1;
      this.hasColor2 = this.frameXml.indexOf('#12FF00') !== -1;
      this.apply();
    });
  }

  close() {
    this.bsModalRef.hide();
  }

  saveAndClose() {

    const colorCodeValidator = /^#([A-Fa-f0-9]{6})$/;

    if (this.img1Error || this.img2Error) {

      return;
    }

    if (!colorCodeValidator.test(this.color1) || !colorCodeValidator.test(this.color2)) {
      this.colorError = true;
      return;
    } else {
      this.colorError = false;
    }

    this.working = true;

    const dataUrl: string = this.imgRef.nativeElement.src;
    const dataBase64: string = dataUrl.substr(dataUrl.indexOf(',') + 1);

    const byteArray = Uint8Array.from(<any>atob(dataBase64), (c: any) => c.charCodeAt(0));

    const blob: any = new Blob([byteArray], { type: 'image/png' });
    blob.name = `${this.selectedFrame.name.replace('filter-', '').replace('-', '_')}.png`;
    this.file = blob;

    this.bsModalRef.hide();
  }

  ngOnInit() {
    this.working = true;
    // load frames
    this.selfieCamService.listFrames().subscribe(frames => {
      this.frames = frames;
      this.selectedFrame = this.frames[0];
      this.loaded = true;
    });

    this.colorChangedObservable.subscribe(() => {
      this.apply();
    });
    this.textChangedObservable.subscribe(() => {
      this.apply();
    });

    const self = this;
    const fontFaceSet = (document as any).fonts;
    if (fontFaceSet && fontFaceSet.addEventListener) {
      fontFaceSet.addEventListener('loadingdone', function() {
        self.apply();
      });
    }
  }
}

interface Color {
  r: number;
  g: number;
  b: number;
}
